module.exports = __webpack_public_path__ + "media/react/assets/CommentIcon-0bc91e0455602f212509a92664940846.svg";